/**
 * Instrumentation Attribute Properties ("Key")
 */
export const instrumentationProperties = {
    ScenarioType: "Action.ScenarioType",
    Scenario: "Action.Scenario",
    PanelType: "Panel.Type",
    GetStarted: "GetStarted",
    LoginStage: "LoginStage",
    LoginErrorType: "LoginErrorType",
    ValidEmail: "ValidEmail",
    LoginFlow: "LoginFlow",
    NumberOfTeams: "NumberOfTeams",
    NumArrowKeysPressed: "NumArrowKeysPressed",
    AutoSelected: "AutoSelected",
    TeamNameLength: "TeamNameLength",
    StartDayOfWeek: "StartDayOfWeek",
    Color: "Color",
    Start: "Start",
    End: "End",
    Unpaid: "Unpaid",
    Paid: "Paid",
    IsGroupByRoles: "IsGroupByRoles",
    IsGroupByTags: "IsGroupByTags",
    IsGroupByShifts: "IsGroupByShifts",
    NumCellsSelected: "NumCellsSelected",
    IsKeyboardShortcut: "IsKeyboardShortcut",
    BootstrapType: "BootstrapType",
    BootstrapCount: "BootstrapCount",
    PageURL: "PageURL",
    PageName: "PageName",
    LandingPageMode: "LandingPageMode",
    IsWarmBootup: "IsWarmBootup",
    TimeToLoadPage: "TimeToLoadPage",
    TimeToBootstrap: "TimeToBootstrap",
    TimeToInteractive: "TimeToInteractive",
    TimeSinceLandingPageMs: "TimeSinceLandingPageMs",
    CameFromLandingPage: "CameFromLandingPage",
    NetworkLatency: "NetworkLatency",
    ProgressiveRenderCount: "ProgressiveRenderCount",
    DidProgressiveRenderComplete: "DidProgressiveRenderComplete",
    ClientSideLoad: "ClientSideLoad",
    Duration: "Duration",
    DurationSincePageLoadStart: "DurationSincePageLoadStart",
    EntryPoint: "EntryPoint",
    NumberOfOpenShifts: "NumberOfOpenShifts",
    NumberOfAssignedShifts: "NumberOfAssignedShifts",
    NumberOfPublishedOpenShifts: "NumberOfPublishedOpenShifts",
    NumberOfPublishedAssignedShifts: "NumberOfPublishedAssignedShifts",
    CopiedWithNotes: "CopiedWithNotes",
    CopiedWithTimeOffs: "CopiedWithTimeOffs",
    CopiedWithActivities: "CopiedWithActivities",
    CopiedWithOpenShifts: "CopiedWithOpenShifts",
    ScheduleRepetition: "ScheduleRepetition",
    CopyScheduleNotificationRecieved: "CopyScheduleNotificationRecieved",
    CopyScheduleSyncShiftsWithoutNotification: "CopyScheduleSyncShiftsWithoutNotification",
    JobSubmittedSuccessfully: "JobSubmittedSuccessfully",
    CompletedSuccessfully: "CompletedSuccessfully",
    UndoSyncNotificationRecieved: "UndoSyncNotificationRecieved",
    CopyScheduleShortCopy: "CopyScheduleShortCopy",
    MultiPagePdf: "MultiPagePdf",
    TeamSettingKey: "TeamSettingKey",
    ContextMenuItem: "ContextMenuItem",
    ContextMenu: "ContextMenu",
    ConnectionState: "ConnectionState",
    ReconnectRetryCount: "ReconnectRetryCount",
    IsTimeOff: "IsTimeOff",
    IsAllDayEvent: "IsAllDayEvent",
    TimeOffReason: "TimeOffReason",
    DurationDays: "DurationDays",
    ShiftType: "ShiftType",
    NoteLength: "NoteLength",
    ViewType: "ViewType",
    CellType: "CellType",
    ActionType: "ActionType",
    IsFilteredItemSelected: "IsFilteredItemSelected",
    HasPhoneNumber: "HasPhoneNumber",
    HasEmailAddress: "HasEmailAddress",
    HasFirstName: "HasFirstName",
    HasLastName: "HasLastName",
    HasPermission: "HasPermission",
    IsAdmin: "IsAdmin",
    ReorderType: "ReorderType",
    ReorderExitType: "ReorderExitType",
    ContactInfo: "ContactInfo",
    SelectionType: "SelectionType",
    IsNewEvent: "IsNewEvent",
    WasApproved: "WasApproved",
    WasReasonProvided: "WasReasonProvided",
    DoIncludeDailyHours: "DoIncludeDailyHours",
    DoIncludeTimeOffs: "DoIncludeTimeOffs",
    DoIncludeSwaps: "DoIncludeSwaps",
    DoIncludeShiftNotes: "DoIncludeShiftNotes",
    IsDateRangeChanged: "IsDateRangeChanged",
    SubmitType: "SubmitType",
    IsWeekSchedulePattern: "IsWeekSchedulePattern",
    DidSchedulePatternChangeStartOfWeek: "DidSchedulePatternChangeStartOfWeek",
    IsFirstRun: "IsFirstRun",
    SchedulePatternLengthIncreased: "SchedulePatternLengthIncreased",
    AlreadyPublished: "AlreadyPublished",
    TeamNameChanged: "TeamNameChanged",
    LocationChanged: "LocationChanged",
    TeamStartingDayOfWeekChanged: "TeamStartingDayOfWeekChanged",
    TimeOffReasonsChanged: "TimeOffReasonsChanged",
    TeamTimeZoneChanged: "TeamTimeZoneChanged",
    TeamCountryCodeChanged: "TeamCountryCodeChanged",
    OpenShiftsChanged: "OpenShiftsChanged",
    OpenShiftsNewValue: "OpenShiftsNewValue",
    CopyShiftActivitiesWithShiftsEnabledChanged: "CopyShiftActivitiesWithShiftsEnabledChanged",
    SwapShiftsRequestsEnabledChanged: "SwapShiftsRequestsEnabledChanged",
    OfferShiftsRequestsEnabledChanged: "OfferShiftsRequestsEnabledChanged",
    TimeOffRequestsEnabledChanged: "TimeOffRequestsEnabledChanged",
    HideLastNameChanged: "HideLastNameChanged",
    HideLastNameNewValue: "HideLastNameNewValue",
    CurrentGroupsCount: "CurrentGroupsCount",
    CurrentView: "CurrentView",
    TypeOfConflict: "TypeOfConflict",
    RequestType: "RequestType",
    RequestURL: "RequestURL",
    RequestEndpoint: "RequestEndpoint",
    ResponseValueCount: "ResponseValueCount",
    Resource: "Resource",
    ClientSessionId: "ClientSessionId",
    ClientRequestId: "ClientRequestId",
    ResponseHttpStatusCode: "ResponseHttpStatusCode",
    ResponseErrorReason: "ResponseErrorReason",
    ResponseContentLengthBytes: "ResponseContentLengthBytes",
    AuthTokenFetchDurationMS: "AuthTokenFetchDurationMS",
    ServiceDurationMS: "ServiceDurationMS",
    NetworkTransitTimeMS: "NetworkTransitTimeMS",
    ClientDurationMS: "ClientDurationMS",
    DurationFromSessionStartMS: "DurationFromSessionStartMS",
    XMsEdgeRef: "XMsEdgeRef",
    ServiceAPIRegionId: "ServiceAPIRegionId",
    // Action: "Action", // Do not use Action as it causes issues for userbi events that begin with 'Action.' https://domoreexp.visualstudio.com/Teamspace/_wiki/wikis/NorthStar%20Docs/5180/user-bi-schema
    FileType: "FileType",
    FileSizeKB: "FileSizeKB",
    GroupProvisioned: "GroupProvisioned",
    DriveProvisioned: "DriveProvisioned",
    ErrorPhone: "ErrorPhone",
    ErrorEmail: "ErrorEmail",
    ErrorFirstName: "ErrorFirstName",
    ErrorLastName: "ErrorLastName",
    ErrorRoleId: "ErrorRoleId",
    IsFromService: "IsFromService",
    IsAddMember: "IsAddMember",
    IsOkPressed: "IsOkPressed",
    TourStopName: "TourStopName",
    TourStopDuration: "TourStopDuration",
    TourStopAttempts: "TourStopAttempts",
    TourDuration: "TourDuration",
    TypeOfNavigation: "TypeOfNavigation",
    Enabled: "IsEnabled",
    NumberOfExtensibilityLinks: "NumberOfExtensibilityLinks",
    NumberOfPowerAppsLinks: "NumberOfPowerAppsLinks",
    NumberOfWebLinks: "NumberOfWebLinks",
    IsCombinedShiftLookup: "IsCombinedShiftLookup",
    TimeToRespondSeconds: "TimeToRespondSeconds",
    ContentGroupNotProvisioned: "Content_GroupNotProvisioned",
    ContentDriveNotProvisioned: "Content_DriveNotProvisioned",
    StatusSucceeded: "StatusSucceeded",
    TitleUpdated: "TitleUpdated",
    TeamTimeZone: "TeamTimeZone",
    DeviceTimeZone: "DeviceTimeZone",
    IsDefault: "IsDefault",
    ToggleOn: "ToggleOn",
    PreviewRetrieved: "PreviewRetrieved",
    BreakAdded: "BreakAdded",
    ActivityTitleLength: "ActivityTitleLength",
    ActivityCodeEntered: "ActivityCodeEntered",
    ActivityCodeLength: "ActivityCodeLength",
    ActivityColor: "ActivityColor",
    ActivityStartTime: "ActivityStartTime",
    ActivityEndTime: "ActivityEndTime",
    ActivityDuration: "ActivityDuration",
    ActivityPaid: "ActivityPaid",
    DeleteActionType: "DeleteActionType",
    ScreenName: "ScreenName",
    IsUserAdmin: "IsUserAdmin",
    StaffHubExceptionCategory: "StaffHubExceptionCategory",
    ErrorHandledAt: "ErrorHandledAt",
    ErrorMessage: "ErrorMessage",
    ErrorCode: "ErrorCode",
    ErrorStacktrace: "ErrorStacktrace",
    ErrorSubError: "ErrorSubError",
    FreTypes: "FreTypes",
    SmartSchedulingFeedbackScenario: "SmartSchedulingFeedbackScenario",
    SmartSchedulingFeedbackKey: "SmartSchedulingFeedbackKey",
    SmartSchedulingFeedbackTimestamp: "SmartSchedulingFeedbackTimestamp",
    IsLocationEnabled: "IsLocationEnabled",
    IsLocationToggled: "IsLocationToggled",
    UserState: "UserState",
    TeamType: "TeamType",
    IsRightClick: "IsRightClick",
    IsAddress: "IsAddress",
    IsAddressChanged: "IsAddressChanged",
    IsCrossLocationOpenShift: "IsCrossLocationOpenShift",
    IsCrossLocationToggleDisabled: "IsCrossLocationToggleDisabled",
    IsEligibilityApiFailed: "IsEligibilityApiFailed",
    AreCLSPrerequisitesMet: "AreCLSPrerequisitesMet",
    NumberOfTeamsCLSPublishedTo: "NumberOfTeamsCLSPublishedTo",
    IsTimeClockEnabled: "IsTimeClockEnabled",
    IsTurnOffClicked: "IsTurnOffClicked",
    IsChangeCanceled: "IsChangeCanceled",
    NumberOfActivitiesCopied: "NumberOfActivitiesCopied",
    NumberOfActivitiesPasted: "NumberOfActivitiesPasted",
    ExportedDaysInterval: "ExportedDaysInterval",
    ExportedDaysInPast: "ExportedDaysInPast",
    ExportLegacyTimeReport: "ExportLegacyTimeReport",
    HasActivities: "HasActivities",
    ShiftColor: "ShiftColor",
    ActivitiesCopied: "ActivitiesCopied",
    NumActivities: "NumActivities",
    NumberOfWarnings: "NumberOfWarnings",
    NumberOfMembersAdded: "NumberOfMembersAdded",
    NumberOfOwnersAdded: "NumberOfOwnersAdded",
    NumberOfGroupsAdded: "NumberOfGroupsAdded",
    NumberOfGroupsUpdated: "NumberOfGroupsUpdated",
    NumberOfShiftsAdded: "NumberOfShiftsAdded",
    ErrorType: "ErrorType",
    ErrorTitle: "ErrorTitle",
    ErrorPrimaryText: "ErrorPrimaryText",
    IsFieldEmpty: "IsFieldEmpty",
    CustomFieldChanged: "CustomFieldChanged",
    CustomFieldAction: "CustomFieldAction",
    Name: "Name",
    Description: "Description",
    Type: "Type",
    CurrentNumDropdownItems: "CurrentNumDropdownItems",
    DropdownItemAction: "DropdownItemAction",
    CurrentNumCustomFields: "CurrentNumCustomFields",
    HaveCustomFields: "HaveCustomFields",
    AreaClicked: "AreaClicked",
    CurrentScreen: "CurrentScreen",
    ArticleTitle: "ArticleTitle",
    HasScreenshot: "HasScreenshot",
    Error: "Error",
    Stage: "Stage",
    ServiceAccountUpdated: "ServiceAccountUpdated",
    ADFSAuthEnabled: "ADFSAuthEnabled",
    ADFSUrlUpdated: "ADFSUrlUpdated",
    ChangeSource: "ChangeSource",
    ChangeType: "ChangeType",
    NumberShiftsChanged: "NumberShiftsChanged",
    FallbackUsed: "FallbackUsed",
    WaffleClicked: "WaffleClicked",
    Reason: "Reason",
    TypeOfShift: "TypeOfShift",
    EventType: "EventType",
    DaysBetweenRanges: "DaysBetweenRanges",
    DurationInDays: "DurationInDays",
    DialogAction: "DialogAction",
    FlowPicked: "FlowPicked",
    DidUserChangeClassification: "DidUserChangeClassification",
    Status: "Status",
    MembersReturned: "MembersReturned",
    MembersSelected: "MembersSelected",
    MembersImportAll: "MembersImportAll",
    WorkEmailsEntered: "WorkEmailsEntered",
    PhoneNumbersEntered: "PhoneNumbersEntered",
    IsOpenShift: "IsOpenShift",
    TeamSize: "TeamSize",
    ScheduleGridRowCount: "ScheduleGridRowCount",
    IsViewGrouped: "IsViewGrouped",
    ScheduleCalendarType: "ScheduleCalendarType",
    ScheduleOverViewType: "ScheduleOverViewType",
    ViewStartDate: "ViewStartDate",
    ViewEndDate: "ViewEndDate",
    NumOfUsersMissingContactInfo: "NumOfUsersMissingContactInfo",
    TimeToFirstPublish: "TimeToFirstPublish",
    NumOpenShiftsShared: "NumOpenShiftsShared",
    NumAssignedShiftsShared: "NumAssignedShiftsShared",
    PublishContainsAutoAssignedShifts: "PublishContainsAutoAssignedShifts",
    NumAutoAssignedShiftsPublished: "NumAutoAssignedShiftsPublished",
    // Count of AOS-produced shifts in the publish range whose server-set `isReassignedAfterGeneration`
    // is true — i.e. the manager reassigned them to a different member after the auto-assign job
    // completed. Stronger / server-authoritative version of the client-side drag-drop tracking
    // (DragAndDrop_ShiftDropCompleted with GenerationSource).
    NumAutoAssignedShiftsReassignedAndPublished: "NumAutoAssignedShiftsReassignedAndPublished",
    AssignedUserId: "AssignedUserId",
    ShiftDurationHours: "ShiftDurationHours",
    WeekStart: "WeekStart",
    ShiftId: "ShiftId",
    ShiftStartTimeUtc: "ShiftStartTimeUtc",
    ShiftEndTimeUtc: "ShiftEndTimeUtc",
    NumWhitelistedSenders: "NumWhitelistedSenders",
    ScaleToOnePage: "ScaleToOnePage",
    ScaleToOnePageSize: "ScaleToOnePageSize",
    ScaleToOnePageStyle: "ScaleToOnePageStyle",
    PrintTeamSize: "TeamSize",
    PeopleOrShiftView: "PeopleOrShiftView",
    TimeTaken: "TimeTaken",
    ReferralSource: "ReferralSource",
    MenuItem: "MenuItem",
    IsRead: "IsRead",
    ViewedBy: "ViewedBy",
    RequestState: "RequestState",
    UploadSuccess: "UploadSuccess",
    ImportSuccess: "ImportSuccess",
    IsSuccess: "IsSuccess",
    ImportExcelSampleFileDownloaded: "ImportExcelSampleFileDownloaded",
    ImportExcelFailedWeb: "ImportExcelFailedWeb",
    ImportExcelErrorsDownloaded: "ImportExcelErrorsDownloaded",
    ImportExcelStartImportAgainClicked: "ImportExcelStartImportAgainClicked",
    ImportExcelTryAgainClicked: "ImportExcelTryAgainClicked",
    ImportExcelSyncNotificationReceived: "ImportExcelSyncNotificationReceived",
    ImportExcelBannerMessageReceived: "ImportExcelBannerMessageReceived",
    ImportExcelErrorsDownloadedFromBanner: "ImportExcelErrorsDownloadedFromBanner",
    ReorderMemberFailed: "ReorderMemberFailed",
    EnablingTimeClockFailed: "EnablingTimeClockFailed",
    SavingTimeClockSettingsFailed: "SavingTimeClockSettingsFailed",
    RenderDuration: "RenderDuration",
    RenderCount: "RenderCount",
    IsDataAvailable: "IsDataAvailable",
    TeamsCount: "TeamsCount",
    TeamSetupOption: "TeamSetupOption",
    TeamSetupAreCustomFieldsSetup: "TeamSetupAreCustomFieldsSetup",
    TeamSetupHasGroupClassification: "TeamSetupHasGroupClassification",
    TeamSetupCustomFieldsCount: "TeamSetupCustomFieldsCount",
    ActedOnBy: "ActedOnBy",
    ActionTaken: "ActionTaken",
    NumberSlot: "NumberSlot",
    HasDifferentDraftChanges: "HasDifferentDraftChanges",
    HoursFromOpenShiftRequested: "HoursFromOpenShiftRequested",
    ViewRequestClicked: "ViewRequestClicked",
    AllDaySelected: "AllDaySelected",
    DateRange: "DateRange",
    DaysFromRequestSent: "DaysFromRequestSent",
    RecipientHasSamePosition: "RecipientHasSamePosition",
    SenderShiftType: "SenderShiftType",
    RecipientShiftType: "RecipientShiftType",
    IsSameTimeOffTypeSwapped: "IsSameTimeOffTypeSwapped",
    NumSharedShifts: "NumSharedShifts",
    NumDraftShifts: "NumDraftShifts",
    NumOfAssignedDraftShifts: "NumOfAssignedDraftShifts",
    NumOfOpenDraftShifts: "NumOfOpenDraftShifts",
    NumTimeOffRequests: "NumTimeOffRequests",
    NumOpenShifts: "NumOpenShifts",
    NumShiftsWithActivities: "NumShiftsWithActivities",
    NumPrevEmpty: "NumPrevEmpty",
    NumPrevShared: "NumPrevShared",
    NumPrevDraft: "NumPrevDraft",
    NumAdd: "NumAdd",
    NumDelete: "NumDelete",
    NumUpdate: "NumUpdate",
    NumPrevHasActivities: "NumPrevHasActivities",
    NumPostHasActivities: "NumPostHasActivities",
    NumPrevTimeOffRequests: "NumPrevTimeOffRequests",
    NumPrevOpenShifts: "NumPrevOpenShifts",
    NumPostOpenShifts: "NumPostOpenShifts",
    TotalNumTeams: "TotalNumTeams",
    NumStaffHubTeams: "NumStaffHubTeams",
    NumSoftDeletedTeams: "NumSoftDeletedTeams",
    NumProvisionableTeams: "NumProvisionableTeams",
    // TeamSetupRestorableSchedulesPicker — count of soft-deleted schedules offered to restore (view event)
    NumberOfRestorableSchedules: "NumberOfRestorableSchedules",
    // UnknownUserTeamPicker — true/false on whether the "New team and schedule" option is offered
    // (gated by the Teams admin create-team policy). Always emitted with an explicit boolean so the
    // shown vs. not-shown cases are distinguishable from old builds that emit no property at all.
    NewTeamOptionShown: "NewTeamOptionShown",
    ChangedDefault: "ChangedDefault",
    ProvisionScheduleTeamSuccess: "ProvisionScheduleTeamSuccess",
    RestoreScheduleTeamSuccess: "RestoreScheduleTeamSuccess",
    IsRestoreOperation: "IsRestoreOperation",
    Location: "Location",
    MessageShown: "MessageShown",
    OwnShift: "OwnShift",
    AssignedShiftShowingInView: "AssignedShiftShowingInView",
    hasContentDisplayed: "hasContentDisplayed",
    crossLocationTeamId: "crossLocationTeamId",
    NumberRequests: "NumberRequests",
    HoursFromOpenShiftApproved: "HoursFromOpenShiftApproved",
    IsManager: "IsManager",
    HasConflicts: "HasConflicts",
    FPS: "FPS",
    Availability: "Availability",
    RetryCount: "RetryCount",
    IsSilent: "IsSilent",
    NumPages: "NumPages",
    NumOfItems: "NumOfItems",
    NumOfItemsByPage: "NumOfItemsByPage",
    NumOfTagFilters: "NumOfTagFilters",
    NumOfMemberFilters: "NumOfMemberFilters",
    EmployeeViewType: "EmployeeViewType",
    FilterType: "FilterType",
    NumberOfGroupsSelected: "NumberOfGroupsSelected",
    NumberOfMembersSelected: "NumberOfMembersSelected",
    IsActiveShiftFilterSelected: "IsActiveShiftFilterSelected",
    IsTimeoffFilterSelected: "IsTimeoffFilterSelected",
    IsConflictFilterSelected: "IsConflictFilterSelected",
    NoCopyFiltersApplied: "NoCopyFiltersApplied",
    MultiTeamApiForMyShiftCalled: "MultiTeamApiForMyShiftCalled",
    TriggeredByFeature: "TriggeredByFeature",
    HasExternalErrorMessage: "HasExternalErrorMessage",
    Is24HrShiftEnabled: "Is24HrShiftEnabled",
    Is24HrShift: "Is24HrShift",
    IsSenderShift24h: "IsSenderShift24h",
    isRecipientShift24h: "isRecipientShift24h",
    TotalConflictCount: "TotalConflictCount",
    TotalShiftAvailabilityConflictCount: "TotalShiftAvailabilityConflictCount",
    TotalShiftTimeConflictCount: "TotalShiftTimeConflictCount",
    TotalOverlappingShiftConflictCount: "TotalOverlappingShiftConflictCount",
    DidConflictCountExceedLimit: "DidConflictCountExceedLimit",
    DidIgnoreConflictsOnLongShifts: "DidIgnoreConflictsOnLongShifts",
    IsDeepLink: "IsDeepLink",
    DeepLinkSource: "DeepLinkSource",
    CellColumnCount: "CellColumnCount",
    MemberShiftCellCount: "MemberShiftCellCount",
    ColumnsPerRowCount: "ColumnsPerRowCount",
    TemporalItemCount: "TemporalItemCount",
    ShiftTemporalItemCount: "ShiftTemporalItemCount",
    EmptyTemporalItemCount: "EmptyTemporalItemCount",
    RowCellCount: "RowCellCount",
    ConnectorAuthenticationOkClicked: "ConnectorAuthenticationOkClicked",
    ConnectorAuthenticationCancelClicked: "ConnectorAuthenticationCancelClicked",
    ConnectorAuthenticationSuccess: "ConnectorAuthenticationSuccess",
    IsClaimsChallenge: "IsClaimsChallenge",
    IsInteractiveAuthRequired: "IsInteractiveAuthRequired",
    HasRequestableTimeOffReasonsEnabled: "HasRequestableTimeOffReasonsEnabled",
    TeamSettingsName: "TeamSettingsName",
    TeamSettingsValue: "TeamSettingsValue",
    TeamSettingsSuccess: "TeamSettingsSuccess",
    ResourceId: "ResourceId",
    NumCLMEnabledTeamsInRegion: "NumCLMEnabledTeamsInRegion",
    NumShifts: "NumShifts",
    NumOfUserShifts: "NumOfUserShifts",
    ArchiveTeamsCount: "ArchiveTeamsCount",
    ActiveTeamsCount: "ActiveTeamsCount",
    AddedMembersDetails: "AddedMembersDetails",
    Trace: "Trace",
    HasGroupName: "HasGroupName",
    IsNewGroup: "IsNewGroup",
    // Nested App Auth
    IsNestedAppAuth: "IsNestedAppAuth",
    IsNaaChannelRecommended: "IsNaaChannelRecommended",
    IsNaaEcsEnabled: "IsNaaEcsEnabled",
    AuthStage: "AuthStage",
    InitClientDuration: "InitClientDuration",
    GetAccountDuration: "GetAccountDuration",
    SilentTokenDuration: "SilentTokenDuration",
    PopupTokenDuration: "PopupTokenDuration",
    TeamsTokenDuration: "TeamsTokenDuration",
    NewMembersFoundInCDL: "NewMembersFoundInCDL",
    DeletedMembersFoundInCDL: "DeletedMembersFoundInCDL",
    // Delete Schedule
    Etag: "Etag",
    Confirmed: "Confirmed",
    DeleteScheduleButtonClicked: "DeleteScheduleButtonClicked",
    LoadAdminInfoFailure: "LoadAdminInfoFailure",
    // Row drag sequence
    OldIndex: "OldIndex",
    NewIndex: "NewIndex",
    // CLS
    CrossLocationShiftInDefaultTagCount: "CrossLocationShiftInDefaultTagCount",
    NumShiftsFromGDIDR: "NumShiftsFromGDIDR",
    NumberOfCrossLocationTeamsPublishedTo: "NumberOfCrossLocationTeamsPublishedTo",
    NumberOfCrossLocationTeamsInTenant: "NumberOfCrossLocationTeamsInTenant",
    // Smart scheduling
    TagNameLinkClickedOnBanner: "TagNameLinkClickedOnBanner",
    PredraftShiftsCount: "PredraftShiftsCount",
    PredraftOpenShiftsCount: "PredraftOpenShiftsCount",
    ShiftBlocksCount: "ShiftBlocksCount",
    NewShiftBlocksToSaveOrDiscardCount: "NewShiftBlocksToSaveOrDiscardCount",
    TotalScheduleGroupsCount: "TotalScheduleGroupsCount",
    VisibleScheduleGroupsCount: "VisibleScheduleGroupsCount",
    // Assign Open Shifts — logged on PageRender / PageView for the schedules page.
    // NumberOpenShifts is the sum of remaining open slots across every active assignable
    // open shift in view. IsAutoAssignButtonEnabled mirrors the "Assign open shifts"
    // command bar button's clickable state (ECS flag on, no in-flight jobs, view has
    // assignable shifts, not month-view-blocked, hideOpenShifts user setting off).
    NumberOpenShifts: "NumberOpenShifts",
    IsAutoAssignButtonEnabled: "IsAutoAssignButtonEnabled",
    // Assign Open Shifts — logged on AssignOpenShifts_AssignCompleted (fires on Success
    // and Failure terminal states from the polling service; not on Canceled). Success
    // distinguishes the two paths. NumShiftsAssigned / NumShiftsUnassigned are slot
    // counts (matching NumberOpenShifts semantics — `openSlots`, not entity counts).
    // TimeToAssign is end-to-end user-perceived latency: time from the user clicking
    // Assign in the dialog (captured before generateScheduleWithHistory) to the polling
    // service detecting the terminal state. Bucketed by ~5-second polling cadence.
    Success: "Success",
    AllShiftsAssigned: "AllShiftsAssigned",
    NumShiftsAssigned: "NumShiftsAssigned",
    NumShiftsUnassigned: "NumShiftsUnassigned",
    TimeToAssign: "TimeToAssign",
    // Assign Open Shifts — logged on AssignOpenShifts_AssignCompleted. Convenience boolean that
    // pairs with AllShiftsAssigned to bucket outcomes on dashboards: true when the run filled
    // zero slots (algorithm errored OR ran cleanly but no eligible members / constraints too tight).
    ZeroShiftsAssigned: "ZeroShiftsAssigned",
    // Assign Open Shifts — logged on AssignOpenShifts_CommandClicked. Counts of groups the dialog
    // picker will render, split by whether the AssignOpenShiftsMaxGroupSize ECS threshold permits
    // selection. NumActiveGroups + NumDisabledGroups == total rows in the picker.
    NumActiveGroups: "NumActiveGroups",
    NumDisabledGroups: "NumDisabledGroups",
    // Assign Open Shifts — logged on AssignOpenShifts_UndoClicked to distinguish whether the
    // Undo link the user clicked lived on the full-success toast (intent="success") or the
    // partial-success toast (intent="warning"). Value comes from InstrumentationService.values
    // (SuccessToast / WarningToast).
    ToastType: "ToastType",
    // Assign Open Shifts — logged on AssignOpenShifts_AssignClicked. True when the team has
    // any scheduling constraint configured (enabled AND non-zero). Mirrors the dialog's
    // "no rules set" check (`isAllOffOrZero`). False on first-time / unconfigured teams.
    CustomRulesApplied: "CustomRulesApplied",
    SchedulingTagId: "SchedulingTagId",
    ClickedatTagLocation: "ClickedatTagLocation",
    // Mute Schedule Groups
    ScheduleGroupId: "ScheduleGroupId",
    IsMuted: "IsMuted",
    LazyCreated: "LazyCreated",
    // Drag-and-drop move characterization
    IsCrossMemberDragged: "IsCrossMemberDragged",
    IsCrossGroupDragged: "IsCrossGroupDragged",
    IsConvertedToOpenShiftOnDrag: "IsConvertedToOpenShiftOnDrag",
    // Post-AOS action tracking — see docs/design/assign-open-shifts-post-assignment-tracking.md.
    // GenerationSource is logged on action events (drag-drop, context menu delete/move-to-open,
    // editor delete) when the affected shift carries an AOS provenance marker; lets dashboards
    // count manager rejections of AOS-produced shifts. IsCrossDateReassignment paired with the
    // existing IsCrossMemberDragged distinguishes "manager rejected the pick" (same-date) from
    // "manager rescheduled" (different-date) on drag-drop. NumAosShiftsDeleted is the multi-shift
    // equivalent of GenerationSource for selection-based deletes (Shift_Delete event).
    GenerationSource: "GenerationSource",
    IsCrossDateReassignment: "IsCrossDateReassignment",
    NumAosShiftsDeleted: "NumAosShiftsDeleted",
    // Drag-to-multiselect characterization
    PaddingArea: "PaddingArea",
    // Assign Open Shifts rules
    MaxWeeklyHoursEnabled: "maxWeeklyHoursEnabled",
    MaxDailyHoursEnabled: "maxDailyHoursEnabled",
    MaxDaysWorkedPerWeekEnabled: "maxDaysWorkedPerWeekEnabled",
    MaxConsecutiveDaysWorkedEnabled: "maxConsecutiveDaysWorkedEnabled",
    MinRestPeriodBetweenShiftsEnabled: "minRestPeriodBetweenShiftsEnabled",
    MinConsecutiveHoursOffPerWeekEnabled: "minConsecutiveHoursOffPerWeekEnabled",
    PreviousColor: "PreviousColor",
    BlankScheduleToPublishMs: "BlankScheduleToPublishMs",
    TotalAssignedShiftHours: "TotalAssignedShiftHours",
    TotalOpenShiftHours: "TotalOpenShiftHours",
    IsMultiSelect: "IsMultiSelect",
    SelectedCellCount: "SelectedCellCount",
    NumShiftsPublishedToMeCurrentWeek: "NumShiftsPublishedToMeCurrentWeek",
    NumHoursPublishedToMeCurrentWeek: "NumHoursPublishedToMeCurrentWeek",
    NumShiftsPublishedToMyTeamCurrentWeek: "NumShiftsPublishedToMyTeamCurrentWeek",
    NumMyTeamWithTwentyHoursCurrentWeek: "NumMyTeamWithTwentyHoursCurrentWeek",
    NumShiftsPublishedToMe: "NumShiftsPublishedToMe",
    NumHoursPublishedToMe: "NumHoursPublishedToMe",
    NumShiftsPublishedToMyTeam: "NumShiftsPublishedToMyTeam",
    NumMyTeamWithTwentyHours: "NumMyTeamWithTwentyHours",
    OnboardingUserCanCreateTeam: "OnboardingUserCanCreateTeam",
    OnboardingPageLoadedFor: "OnboardingPageLoadedFor",
    ScheduleHasNeverBeenPublished: "ScheduleHasNeverBeenPublished"
};